// frontend/src/askos/SavedResourcesPage.js
//
// Lists everything the student has bookmarked via BookmarkButton, grouped
// by type, with a remove action — replaces the earlier StubPage.
import React, { useEffect, useState, useCallback } from 'react';
import { listBookmarks, deleteBookmark } from '../api/bookmarksApi';

const TYPE_LABELS = {
    teaching_material: 'Teaching Material',
    content_block: 'Studio Notes',
    concept: 'Topic',
    current_affairs: 'Current Affairs',
    pyq_question: 'PYQ Question',
};

const SavedResourcesPage = ({ slug }) => {
    const [bookmarks, setBookmarks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [typeFilter, setTypeFilter] = useState('');

    const load = useCallback(() => {
        setLoading(true);
        listBookmarks(slug)
            .then(setBookmarks)
            .catch(() => setBookmarks([]))
            .finally(() => setLoading(false));
    }, [slug]);

    useEffect(() => { load(); }, [load]);

    const remove = async (id) => {
        setBookmarks(prev => prev.filter(b => b.id !== id));
        try {
            await deleteBookmark(slug, id);
        } catch {
            load(); // reconcile on failure
        }
    };

    const types = Array.from(new Set(bookmarks.map(b => b.type)));
    const visible = typeFilter ? bookmarks.filter(b => b.type === typeFilter) : bookmarks;

    return (
        <div className="subpage">
            <h2>Saved Resources</h2>

            {types.length > 0 && (
                <div className="filter-row saved-resources-tabs">
                    <button type="button" className={`filter-chip ${!typeFilter ? 'active' : ''}`} onClick={() => setTypeFilter('')}>All</button>
                    {types.map(t => (
                        <button
                            key={t}
                            type="button"
                            className={`filter-chip ${typeFilter === t ? 'active' : ''}`}
                            onClick={() => setTypeFilter(t)}
                        >
                            {TYPE_LABELS[t] || t}
                        </button>
                    ))}
                </div>
            )}

            {loading && <p className="empty-note">Loading…</p>}
            {!loading && bookmarks.length === 0 && (
                <p className="empty-note">Nothing saved yet — use the ☆ Save button on chat answers, current affairs, PYQ questions and reading material to bookmark them here.</p>
            )}

            {!loading && visible.map(b => (
                <div key={b.id} className="saved-resource-row">
                    <div>
                        <span className="type-tag">{TYPE_LABELS[b.type] || b.type}</span>
                        <div>{b.title}</div>
                        {b.snippet && <p className="snippet">{b.snippet}</p>}
                        {b.note && <p className="note">{b.note}</p>}
                    </div>
                    <button type="button" className="remove-btn" onClick={() => remove(b.id)}>Remove</button>
                </div>
            ))}
        </div>
    );
};

export default SavedResourcesPage;
